import React, { useState, useEffect } from 'react';
import * as Yup from "yup";
import AuthServiceForm from './AuthServiceForm'
import { Paper, withStyles, Dialog, CircularProgress } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { parseURL } from "../../sc-utilities";
import { connect } from "react-redux";
import * as actions from "./store/authServiceActions";
import History from "../../../History";
import AppLogoLoading from '../../sc-logo';
import config from "../../../config/config";

const styles = theme => ({
  root: {
    width: 'auto',
    height: 'auto',
    padding: theme.spacing(2),
    paddingRight: theme.spacing(6),
    margin: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      margin: 0,
      paddingRight: 0,
    }
  },
  submit: {
    backgroundColor: "transparent",
    boxShadow: "none",
    overflow: "hidden",
    alignItems: "center"
  },
  cancel: {
    width: "250px",
    margin: "10px"
  }
});

const AuthServiceEdit = props => {
  const { authService, classes, onFetchAuthServiceInit, activeCustomer, translations, permissions, onFetchAuthService, onEditAuthService } = props;
  const [data, setData] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await onFetchAuthService({ ActiveCustomerID: activeCustomer, AuthServiceID: parseURL(window.location.href).authServiceID });
      setData(false);
    }
    fetchData();
    return () => {
      onFetchAuthServiceInit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleSubmit = async data => {
    let objectToSend = { ...data };
    objectToSend['AuthServiceID'] = authService.AuthServiceID;
    let result = await onEditAuthService({ ...objectToSend, ActiveCustomerID: activeCustomer });
    if (result) {
      History.goBack()
    }
  };

  let initialValues = {
    Name: authService?.Name || "",
    Type: authService?.Type || "",
    Active: authService?.Active || false,
    BaseURL: authService?.BaseURL || "",
    ClientID: authService?.Configuration?.ClientID || "",
    ClientSecret: authService?.Configuration?.ClientSecret || "",
    GrantTypes: authService?.Configuration?.GrantTypes || "authorization_code",
    ResponseTypes: authService?.Configuration?.ResponseTypes || "code",
    RedirectURIs: authService?.Configuration?.RedirectURIs || `${config.backend_url}/openid/callback`,
    AutoCreateTechnicalUser: authService?.Configuration?.AutoCreateTechnicalUser || false,
    TechnicalUserNameFormat: authService?.Configuration?.TechnicalUserNameFormat || "{FirstName}_{LastName}-{UserID}",
    TechnicalUserDefaultFirstName: authService?.Configuration?.TechnicalUserDefaultFirstName || "Technical",
    TechnicalUserDefaultLastName: authService?.Configuration?.TechnicalUserDefaultLastName || "User"
  };

  let formSettings = {
    Validation: {
      Name: Yup.string().required("Required"),
      Type: Yup.string().required("Required"),
      Active: Yup.boolean().required("Required"),
      BaseURL: Yup.string().required("Required"),
      ClientID: Yup.string().when('Type', {
        is: 'openid',
        then: Yup.string().required("Required"),
      }),
      ClientSecret: Yup.string().when('Type', {
        is: 'openid',
        then: Yup.string().required("Required"),
      }),
      GrantTypes: Yup.string().when('Type', {
        is: 'openid',
        then: Yup.string().required("Required"),
      }),
      ResponseTypes: Yup.string().when('Type', {
        is: 'openid',
        then: Yup.string().required("Required"),
      }),
      RedirectURIs: Yup.string().when('Type', {
        is: 'openid',
        then: Yup.string().required("Required"),
      }),
      AutoCreateTechnicalUser: Yup.boolean().when('Type', {
        is: 'openid',
        then: Yup.boolean().required("Required"),
      }),
      TechnicalUserNameFormat: Yup.string().when('AutoCreateTechnicalUser', {
        is: true,
        then: Yup.string().required("Required"),
      }),
      TechnicalUserDefaultFirstName: Yup.string().when('AutoCreateTechnicalUser', {
        is: true,
        then: Yup.string().required("Required"),
      }),
      TechnicalUserDefaultLastName: Yup.string().when('AutoCreateTechnicalUser', {
        is: true,
        then: Yup.string().required("Required"),
      })
    },
    FormTitle: translations['edit_auth_service'] || 'Edit Authorization Service',
    ButtonSubmit: hasPermission(permissions, "auth_service_save") ? {
      Title: translations["save"] || "SAVE",
      Color: 'primary'
    } : null
  };

  return (
    <Paper className={classes.root} >
      {BackButton(translations)}
      <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data}
        PaperProps={{
          classes: {
            root: classes.submit
          }
        }} >

        <AppLogoLoading />
      </Dialog>
      {!data ?
        <AuthServiceForm
          formSettings={formSettings}
          initialValues={initialValues}
          handleSubmit={handleSubmit}
          translations={translations}
        />
        : <CircularProgress
          variant='determinate'
          color='primary'
          size={28}
        />}
    </Paper>)
}

const mapStateToProps = state => {
  return {
    activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
    permissions: state?.core?.login?.permissions || [],
    authService: state?.setting?.authService?.loaded || {},
    translations: state?.translate?.translations?.activeTranslations || {}
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchAuthServiceInit: authService => dispatch(actions.loadAuthServiceInit(authService)),
    onFetchAuthService: authService => dispatch(actions.loadAuthService(authService)),
    onEditAuthService: authService => dispatch(actions.editAuthService(authService)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(AuthServiceEdit));
